import request from './axios.config'

export default request
